// extracted by mini-css-extract-plugin
export default {"card":"d4-z"};